module.exports = __webpack_public_path__ + "static/media/khouloud.45fb23b8.jpg";